document.addEventListener('change', function(e) {
  const select = e.target.closest('.QuickAdd__VariantSelect');
  if (!select) return;

  const card = select.closest('.ProductItem');
  const button = card.querySelector('.QuickAdd__Button');
  button.dataset.variantId = select.value;

  // Disable button if variant is sold out
  const selectedOption = select.options[select.selectedIndex];
  button.disabled = selectedOption.dataset.available === "false";
});

document.addEventListener('click', function(e) {
  const button = e.target.closest('.QuickAdd__Button');
  if (!button) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  button.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(res => res.json())
  .finally(() => {
    // Re-enable button after request completes
    button.disabled = false;
  });
});

